import campaignsLogic from './campaigns.js';
export default (function () {
  if (document.querySelectorAll('.campaign-phone-number').length || document.querySelectorAll('[href*="//cignasupplemental.expressenroll.com"]').length) {
    campaignsLogic();
  }
});